import styled from "@emotion/styled";

export const Container = styled.div<{ isBlocked: boolean }>`
  display: flex;
  min-width: 480px;
  padding: 20px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  height: max-content;

  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  background: ${(props) =>
    props.isBlocked ? "var(--alias-color-interaction-disabled)" : "var(--alias-color-background-normal-normal)"};
`;

export const ImageContainer = styled.div<{ image?: string; isBlocked: boolean }>`
  display: flex;
  width: 180px;
  height: 180px;
  justify-content: center;
  align-items: center;

  border-radius: 12px;
  background: ${(props) => (props.image ? "white" : "var(--component-color-fill-alternative)")};
  background-image: url(${(props) => props.image});
  opacity: ${(props) => (props.isBlocked ? 0.3 : 1)};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  max-width: calc(100% - 200px);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 16px;
  flex: 1 0 0;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;
